/**
 * This is going to be a replacement for the angularJS version
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class AutoremindService {

    constructor(private httpClient: HttpClient) {
    }

    getTemplatesForAR3User(): Observable<Array<any>> {
        return this.httpClient
            .get('servlets/autoremind/templates/', {observe: 'body'})
            .pipe(
                map((response: any) => response)
            );
    }
}
